// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"380e34f2","353":"4e9e72ae"}[chunkId] + ".chunk.css";
};